<form nz-form [formGroup]="form">
    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{'Common.Name' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control">
            <wx-localized-text-input formControlName="name"></wx-localized-text-input>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{'Common.Type' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="'Common.Type' | translate | requiredMessage">
            <nz-select formControlName="dataType"  [nzAllowClear]="true">
                <nz-option *ngFor="let item of dataTypes" [nzValue]="item.value" [nzLabel]="item.name | translate" ></nz-option>
            </nz-select>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{'Common.Description' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" >
            <textarea nz-input formControlName="description" [rows]="3" [maxlength]="500"></textarea>
        </nz-form-control>
    </nz-form-item>
</form>
<div *nzModalFooter>
    <button (click)="cancel()" nz-button>{{'Common.Cancel' | translate}}</button>
    <button (click)="save()" nz-button nzType="primary">{{'Common.Confirm' | translate}}</button>
</div>